<template>
<div>

  <div v-if="type=='A'">

  <div v-if="newSupplier">
    <newSupplier @close="newSupplier=false" :item={}></newSupplier>
  </div> 

  <div v-else>
  
    <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
          <li @click="$emit('close')" class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA A RICERCA ORDINE</a></li>
          <li @click="newSupplier=true" class="breadcrumb-item"><a href="#">
            <i style="color:rgb(18, 50, 228)" class="fas fa-plus mr-2" aria-hidden="true"></i>
            NUOVO FORNITORE</a></li>
          
          </ol>
        </nav>  

  <form id="order" v-on:submit.prevent="submit()" >

      <h4><i class="fas fa-edit mr-2" aria-hidden="true"></i>NUOVO ORDINE - INTESTAZIONE</h4>
          
      <div class="form-group">

        

        <!--
        <button @click="$emit('close')" type="button"  class="btn  btn-secondary mr-2">
                <i style="color:yellow"  class="fas fa-reply mr-2" aria-hidden="true"></i>
                RITORNA A RICERCA ORDINE
    </button>   
        <button @click="newSupplier=true" type="button"  class="btn btn-success ">
                <i style="color:yellow"  class="fas fa-plus mr-2" aria-hidden="true"></i>
                NUOVO FORNITORE
      </button> 
    -->                
        <supplier-select  v-bind:Id="order.supplierId" v-bind:isActive="true" @update="setSupplierId"></supplier-select>
      </div>
      
      <div class="form-group">   
        <season-select v-bind:Id="order.seasonId" v-bind:isActive="true"   v-bind:type="true"  @update="setSeasonId"></season-select>
      </div> 
      <div class="form-group">
        <year-select v-bind:_year="order.season_year" v-bind:required="true"  v-bind:isActive="true" @update="setYear"></year-select>
      </div>
      <div class="form-group">
        <label for="number_doc"><strong>Numero ordine</strong></label>
        <input v-model="order.order_num" type="text" class="form-control bold" placeholder=""  id = "order_num" required>
      </div>
      <div class="form-group">
        <label for="order_date"><strong>Data ordine</strong></label>
        <input required v-model="order.order_date" type="date" class="form-control bold" placeholder="" id = "order_date">
      </div>
      <div class="form-group">
        <store-select v-bind:Id="order.storeId"  @update="setStoreId" v-bind:isActive="true" v-bind:required="true"></store-select>
      </div>
          
      <alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg" ></alert-box> 

    <button :disabled="spinner" type="submit"   class="btn btn-primary float-right mr-3">
      <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
      PROCEDI
      <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
    
  </form>

  </div>



  </div>

  <div v-else>
     <form id="order" v-on:submit.prevent="submit2()" >
     <alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg" ></alert-box>    
    <div class="card border-info">
      <div  class="card-header text-white bg-info">
        <h4><i class="fas fa-edit mr-2" aria-hidden="true"></i>MODIFICA INTESTAZIONE ORDINE</h4>
      </div>
      <div style="color:black" class="card-body">
        
      <div class="form-group">                
        <supplier-select   v-bind:Id="order.supplierId" v-bind:isActive="false" @update="setSupplierId"></supplier-select>
      </div>
      <div class="form-group">   
        <season-select v-bind:Id="order.seasonId" v-bind:isActive="true"   v-bind:type="true"  @update="setSeasonId"></season-select>
      </div> 
      <div class="form-group">
        <year-select v-bind:_year="order.season_year" v-bind:required="true"  v-bind:isActive="true" @update="setYear"></year-select>
      </div>
      <div class="form-group">
        <label for="number_doc"><strong>NUMERO ORDINE</strong></label>
        <input v-model="order.order_num" type="text" class="form-control bold" placeholder=""  id = "order_num" required>
      </div>
      <div class="form-group">
        <label for="order_date"><strong>DATA ORDINE</strong></label>
        <input required v-model="order.date" type="date" class="form-control bold" placeholder="" id = "order_date">
      </div>

      <div class="form-group">
        <store-select :key="refresh" v-bind:Id="order.storeId"  @update="setStoreId" v-bind:isActive="true" v-bind:required="true"></store-select>
      </div>
      
      </div>

     
    </div>
        
    <button :disabled="spinner" type="submit"   class="btn btn-primary float-right mr-3 mt-1">
      <i class="fas fa-save mr-2" aria-hidden="true"></i>
      MODIFICA
      <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>
    
  </form>


  </div>  

<!-- MAIN DIV -->
</div>

</template>
<script>


import api              from '@/api'
import supplierSelect   from '@/components/common/SupplierSelect.vue'   
import seasonSelect     from '@/components/common/SeasonSelect.vue'   
import yearSelect       from '@/components/common/YearSelect.vue' 
import storeSelect      from '@/components/common/StoreSelect.vue' 
import newSupplier      from '@/components/supplier/Supplier.vue' 

import alertBox         from '@/components/common/AlertBox.vue';


import { mapGetters } from 'vuex';
//import CustomerReturnVue from '../frontOffice/CustomerReturn.vue'
export default {
  
  components: {supplierSelect,yearSelect,seasonSelect,storeSelect,alertBox,newSupplier},  
  
  props: ['_order','type'],

  data () {
    return {
      newSupplier : false,
      order   : this._order ,      
      spinner : false,
      msg     : {
        title : '',
        body  : '',
        type  : 0
      },
      refresh : 0
      
  }
  },

computed: 
  {

    ...mapGetters(['company'])

  },

mounted()
{
  
  
  

},
created()
{
  
  this.refresh++
  //console.log('REFRESH',this.refresh)
},
methods: 
{

  setSupplierId(supplierId)
  {
    this.order.supplierId = supplierId
  },
  setSeasonId(seasonId)
  {
    this.order.seasonId = seasonId
  },
  setYear(year)
  {
    this.order.season_year = year
  },
  setStoreId(storeId)
  {
    this.order.storeId = storeId
  },


  order_checkIn()
  {
    this.spinner = true
    var data     = {}
    data         = this.order    

    var sp   = {'sp' : 'spOrder_CheckIn'}
    var json = Object.assign(data, sp,{'companyId' : this.company.Id});
   
    return new Promise(async  (resolve, reject)  =>  {

    await api.post(json).then(res => {
        if(res.status==200)
          {
            if(res.data.recordsets[0].length > 0)
            {
            
              this.order = res.data.recordsets[0][0]
            }
        
            resolve({'status':'OK','data': res.data.recordsets[0].length > 0})              
          }
          else if(res.status==500)
          {
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

             resolve({'status':'ERR','data': false})              
          }
           
          else
          {
                        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1
            resolve({'status':'ERR','data': false})   
            
          } 
      }).catch(err => 
      {
  
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1
          resolve({'status':'ERR','data': false})   
            
      }).finally(() => {
        this.spinner = false
      });    






    })

  },
  async submit() 
  {
    
    var checkIn = await this.order_checkIn()
    
    if(checkIn.status == 'ERR')
    {
      return
    }

    // ORDINE ESISTENTE
    if(checkIn.status == 'OK' && checkIn.data)
    {
      
      this.$emit('update',this.order)
      return
    }
    

    this.spinner = true
    
    var data  = this.order    
    var sp    = {'sp':'spCreateSupplierOrder'}
    var json  = Object.assign(data, sp,{'companyId':this.company.Id});
  
    await api.post(json).then(res => {
      if(res.status==200)
        {
          this.order.orderId = res.data.recordsets[0][0].orderId
          this.$emit('update',this.order)         
        }
        else if(res.status==500)
        {
          console.log(res.data)

        } 
        else
        {
          console.log('Network Error.')                  
        } 
    }).catch(err => 
    {
      console.log(err.message)    
    }).finally(() => {
      this.spinner = false
    });
   
	},
  
  async submit2() 
  {
    
 
    this.msg.title = ''
   
    this.spinner = true
    
    const data  = this.order  
    
    const sp   = {'sp':'spUpdateOrderHeader'}
    const json = Object.assign(data, sp,{'companyId':this.company.Id});
   
    await api.post(json).then(res => {
      if(res.status==200)
        {
   
          if(res.data.recordsets[0][0].orderId == 0)
          {
             this.msg.title = 'ATTENZIONE '
             this.msg.body = 'Intestazione ordine già esistente.'
             this.msg.type = 1
          }
          else
          {
             this.msg.title = 'MODIFICA EFFETTUATA '
             this.msg.body = ''
             this.msg.type = 0
          }
          
        }
        else if(res.status==500)
        {
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res.data
          this.msg.type = 1
          

        } 
        else
        {
          
          this.msg.title = 'ATTENZIONE '
          this.msg.body = 'Errore di rete.'
          this.msg.type = 1
          
        } 
    }).catch(err => 
    {
      
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1
      
      
      
      
    }).finally(() => {
      this.spinner = false
    });







   
   
	}
  
      
}
    
}    
</script>

<style scoped>




 
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}



</style>